<template>
  <a-modal
    title="预览"
    width="70%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :footer="null"
    :maskClosable="true"
    :keyboard="true"
    @cancel="handleCancel"
  >
    <div style="text-align:center;">
      <img v-if="url && url != '-'" class="image" :src="baseURL + url" alt="" />
      <div v-else class="defaultImage">
        <img src="@/assets/images/img53.png" alt="" />
        <p>暂无数据</p>
      </div>
    </div>
  </a-modal>
</template>
  
<script>
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      baseURL,
    };
  },
  props: ["visibles", "url"],
  watch: {
    visibles(newValue) {
      this.visible = newValue;
    },
  },
  methods: {
    handleCancel() {
      this.$emit("handleCancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.image {
  width: auto;
  height: auto;
  max-height: 100%;
  max-width: 100%;
}
/deep/ .ant-modal-title {
  text-align: center;
}
.defaultImage {
  img {
    margin: 0 auto;
    display: block;
    width: 80%;
  }
  p {
    position: absolute;
    bottom: 14%;
    left: 50%;
    font-size: 22px;
    transform: translate(-50%, 0%);
  }
}
</style>
